import React from 'react';
import { Tab } from '@mui/material';
import { ArcTabProps } from './types';

const ArcTab: React.FC<ArcTabProps> = (props) => {
  return <Tab {...props} />;
};

export default ArcTab;